/**
 * AutoCompleteDestinatario
 */
import {$, HttpBody, ID, Resource, ResponseSerialize, TAG} from 'simpli-web-sdk'
import AutoCompleteDestinatarioSchema from '@/schema/AutoCompleteDestinatario.schema'
import {UFInitial} from '@/enums/UFInitial'

export default class AutoCompleteDestinatario extends Resource {

  static async persist(listToPersist: AutoCompleteDestinatario[], spinner = 'persistAutoCompleteDestinatario') {
    const fetch = async () => {
      return await new HttpBody(Number).POST(`/user/auto-complete-destinatario`, listToPersist)
    }

    return await $.await.run(fetch, spinner)
  }

  static async getTotalCadastrado(id: number | string, spinner = 'getTotalDestinatario') {
    const fetch = async () => await new HttpBody<number>().GET(`/user/auto-complete-destinatario/total`)
    return await $.await.run(fetch, spinner)
  }

  readonly $name: string = 'AutoCompleteDestinatario'

  readonly $endpoint: string = '/user/auto-complete-destinatario'

  get $id() {
    return this.idAutoCompleteDestinatarioPk
  }
  set $id(val: ID) {
    this.idAutoCompleteDestinatarioPk = val
  }

  get $tag() {
    return this.nome || ''
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  get $schema() {
    return AutoCompleteDestinatarioSchema(this)
  }

  idAutoCompleteDestinatarioPk: ID = 0
  idResponsavelFk: ID = 0

  nome: string | null = null
  cpfCnpj: string | null = null
  telefone: string | null = null
  email: string | null = null

  logradouro: string | null = null
  numero: string | null = null
  bairro: string | null = null
  cep: string | null = null
  cidade: string | null = null
  complemento: string  | null = null
  uf: UFInitial | null = null
}
